/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AutofocusDirective } from './autofocus.directive';
import { DateAgoPipe } from './date-ago.pipe';

/**
 * Module to house various utility components, directives, and pipes
 */
@NgModule({
  declarations: [
    DateAgoPipe,
    AutofocusDirective,
  ],
  imports: [CommonModule],
  exports: [
    DateAgoPipe,
    AutofocusDirective,
  ],
})
export class UtilsModule {
}
